var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00038 1.33312C4.71162 1.33312 3.66726 2.37749 3.66726 3.66624C3.66726 4.95499 4.71162 6 6.00038 6C7.28913 6 8.3335 4.95501 8.3335 3.66624C8.3335 2.37749 7.28913 1.33312 6.00038 1.33312ZM2.3335 3.66624C2.3335 1.64128 3.97542 0 6.00038 0C8.02534 0 9.66726 1.64128 9.66726 3.66624C9.66726 5.6912 8.02534 7.33312 6.00038 7.33312C3.97542 7.33312 2.3335 5.6912 2.3335 3.66624Z",
    fill: "#373E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6662C0 9.0094 1.34312 7.6662 3 7.6662H9C10.6568 7.6662 12 9.00932 12 10.6662C12 12.3231 10.6569 13.6662 9 13.6662H3C1.3432 13.6662 0 12.3231 0 10.6662ZM3 8.99996C2.07938 8.99996 1.33312 9.74621 1.33312 10.6662C1.33312 11.5868 2.07938 12.3331 3 12.3331H9C9.92062 12.3331 10.6669 11.5868 10.6669 10.6662C10.6669 9.7462 9.92062 8.99996 9 8.99996H3Z",
    fill: "#373E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/Usericon.9945af43ef6c5c1614d9a0a88d073338.svg";
export { ForwardRef as ReactComponent };